import ModalSys from "../../../../components/modal";
import CardSys from "../../../../components/cardSys";
import CloseIcon from "@mui/icons-material/Close";
import { DataGrid } from "@mui/x-data-grid";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { CSVLink } from "react-csv";
import PrintIcon from "@mui/icons-material/Print";
import MultiSelectFilter from "../../components/multiSelectFilter";
import DatepickerFilter from "../../components/dateRage";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ValueRange from "../../components/valueRange";
import { columnsReport, useColumnsModal } from "../../constants/columnsModal";
import { Alert, Avatar, Box, Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton, Menu, MenuItem, Modal, Paper, TablePagination, Toolbar, Tooltip, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { ModalContext } from "../../contexts/ModalContext";
import ButtonGroup from "../buttonGroup";
import useGerarXlsx from "../../hooks/useGerarXlsx";
import { FilterContext } from "../../contexts/FilterContext";
import useTotal from "../../hooks/useTotal";
import { FormControlLabel } from '@mui/material';
import { api } from "../../../../services/api";
import { GlobalAlertContext } from "../../../../contexts/GlobalAlertContext";
import usePdf from "../../hooks/usePdf";

const cols = [
    {
        field: "name",
        headerName: "Name",
        flex: 1
    }
];

export default function ModalReport() {


    const { setPageSize, pageSize, page, selection, modal, handleHide, filter, data, handleValue, compareMin, compareMax, cleanValues, setSelection, refresh, handlePageSize, result, amount, newFilter } = useContext(ModalContext)
    const { generatePdf } = usePdf()
    const { gerarXlsx } = useGerarXlsx();

    const [data2, setData2] = useState([]);

    useEffect(() => {
        (async () => {
            await refresh(0);
        })()
    }, []);

    const {
        devedor,
        contrato,
        CNPJ,
        titulo,
        saldo,
        valor_original,
        data_acordo,
        data_entrada,
        data_finalizacao,
        vencimento,
        motivo
    } = filter

    const link = `/previewPdfAnalitics`;

    const { columnGroupingModel } = useTotal()

    useEffect(() => {
        if (selection?.init) {
            const selects = data.map((el, i) => {
                return el.id
            })
            setSelection({ select: [...selects], init: false })
        }
        return () => {

        }
    }, [])

    const { handleToast, handleLoading } = useContext(GlobalAlertContext);

    const gerarCsv = async (newFilter, groupsSelected, done) => {
        handleLoading(true)
        const idClient = groupsSelected.map(el => {
            return el.id
        })
        const { data: response } = await api({ method: "GET", url: "/source/analiticoPdf/" + idClient + "?&" + newFilter });
        setData2(response.results);
        handleLoading(false)
    }


    const handlePreviw = () => {
        localStorage.setItem("PreviewPDFFilter", newFilter);
    }

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const { columns, visibleLegend } = useColumnsModal()
    const { groupsSelected, header } = useContext(FilterContext)


    return (
        <Modal
            open={modal}
            handleClose={() => {
                handleHide();
                cleanValues()
                setSelection({ init: true, select: [] })
            }}
        >

            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    height: "100vh",
                    width: "100vw",
                    padding: "20px"
                }}
            >
                <CardSys sx={{ width: "100%", height: "auto", overflowY: "auto" }}>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        PaperProps={{
                            style: {
                                backgroundColor: "#F1F6FF",
                            },
                        }}
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"Limite de linhas atingido"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                O limite para gerar o arquivo PDF é de 1000 linhas.<br />
                                Ajuste os critérios de filtro e tente novamente.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" color="blueSys" onClick={handleClose}>Ok</Button>
                        </DialogActions>
                    </Dialog>
                    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", overflowX: "hidden", overflowY: "auto" }}>

                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row-reverse",
                            }}
                        >

                            <IconButton
                                sx={{ m: 0, p: 0, zIndex: 10000 }}
                                onClick={() => {
                                    handleHide()
                                    cleanValues()
                                    setSelection({ init: true, select: [] })
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <Box
                            sx={{
                                border: "10px",
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%"
                            }}
                        >
                            <Grid container spacing={2} columns={20}>
                                <Grid item md={4} xs={10}>
                                    <MultiSelectFilter
                                        title={"Cliente/Devedor"}
                                        options={devedor?.options}
                                        value={devedor?.value}
                                        onChange={(e, elemento) => { handleValue({ field: "devedor", value: elemento }) }}
                                        border={"#00A7E1"}
                                        focused
                                    ></MultiSelectFilter>
                                </Grid>
                                <Grid item xs={10} md={4}>
                                    <MultiSelectFilter
                                        title={"Contrato"}
                                        options={contrato?.options}
                                        value={contrato?.value}
                                        onChange={(e, elemento) => { handleValue({ field: "contrato", value: elemento }) }}
                                        border={"#00A7E1"}
                                    ></MultiSelectFilter>
                                </Grid>
                                <Grid item xs={10} md={3.5}>
                                    <DatepickerFilter
                                        title={"Data de entrada"}
                                        handleStart={(value) => {
                                            handleValue({ field: "data_entrada", value: [value, data_entrada?.value[1]] });

                                        }}
                                        handleEnd={(value) => {
                                            handleValue({ field: "data_entrada", value: [data_entrada?.value[0], value] });

                                        }}
                                        valueStart={data_entrada?.value[0]}
                                        valueEnd={data_entrada?.value[1]}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    borderColor: "#31b3e4",
                                                },
                                            },
                                            ".css-i4bv87-MuiSvgIcon-root": {
                                                color: "#2C4992"
                                            },
                                            ".css-nxo287-MuiInputBase-input-MuiOutlinedInput-input": {
                                                fontSize: "0.9em !important;"
                                            }
                                        }}
                                    ></DatepickerFilter>
                                </Grid>
                                <Grid item xs={10} md={2} sx={{ margin: "0" }}>
                                    <ValueRange
                                        title={"V. Original"}
                                        min={Number(valor_original?.options.sort(compareMin)[0].label)}
                                        max={Number(valor_original?.options.sort(compareMax)[0].label)}
                                        valueLabelFormat={(value) => "R$ " + parseFloat(value).toLocaleString("pt-Br")}
                                        value={!valor_original?.value.length ? [Number(valor_original?.options.sort(compareMin)[0].label), Number(valor_original?.options.sort(compareMax)[0].label)] : valor_original?.value}
                                        onChange={(e, elemento) => { handleValue({ field: "valor_original", value: elemento }) }}
                                    />
                                </Grid>
                                <Grid item xs={10} md={2} sx={{ margin: "0" }}>
                                    <ValueRange
                                        title={"Saldo"}
                                        min={Number(saldo?.options.sort(compareMin)[0].label)}
                                        max={Number(saldo?.options.sort(compareMax)[0].label)}
                                        valueLabelFormat={(value) => "R$ " + parseFloat(value).toLocaleString("pt-Br")}
                                        value={!saldo?.value.length ? [Number(saldo?.options.sort(compareMin)[0].label), Number(saldo?.options.sort(compareMax)[0].label)] : saldo?.value}
                                        onChange={(e, elemento) => { handleValue({ field: "saldo", value: elemento }) }}
                                    />
                                </Grid>
                                {/* <Grid item xs={4}>
                                        <MultiSelectFilter
                                            title={"Título"}
                                            options={titulo?.options}
                                            value={titulo?.value}
                                            onChange={(e, elemento) => handleValue({ field: "titulo", value: elemento })}
                                            border={"#2C4992"}
                                        ></MultiSelectFilter>
                                    </Grid> */}
                                <Grid item xs={10} md={3.5} >
                                    <DatepickerFilter
                                        title={"Data do Acordo"}
                                        handleStart={(value) => {

                                            handleValue({ field: "data_acordo", value: [value, data_acordo?.value[1]] });

                                        }}
                                        handleEnd={(value) => {
                                            handleValue({ field: "data_acordo", value: [data_acordo?.value[0], value] });

                                        }}
                                        valueStart={data_acordo?.value[0]}
                                        valueEnd={data_acordo?.value[1]}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    borderColor: "#E2746F",
                                                },
                                            },
                                            ".css-i4bv87-MuiSvgIcon-root": {
                                                color: "#2C4992"
                                            },
                                            ".css-nxo287-MuiInputBase-input-MuiOutlinedInput-input": {
                                                fontSize: "0.9em !important;"
                                            }
                                        }}
                                    ></DatepickerFilter>
                                </Grid>
                                <Grid item xs={10} md={4}>
                                    <ButtonGroup
                                        title={"Estágio"}
                                    />
                                </Grid>
                                <Grid item xs={10} md={4}>
                                    <MultiSelectFilter
                                        title={"Motivo"}
                                        options={motivo?.options}
                                        value={motivo?.value}
                                        onChange={(e, elemento) => { handleValue({ field: "motivo", value: elemento }) }}
                                        border={"#00A7E1"}
                                    ></MultiSelectFilter>
                                </Grid>
                                <Grid item xs={10} md={3.5}>
                                    <DatepickerFilter
                                        title={"Vencimento"}
                                        handleStart={(value) => {
                                            handleValue({ field: "vencimento", value: [value, vencimento?.value[1]] });

                                        }}
                                        handleEnd={(value) => {
                                            handleValue({ field: "vencimento", value: [vencimento?.value[0], value] });

                                        }}
                                        valueStart={vencimento?.value[0]}
                                        valueEnd={vencimento?.value[1]}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    borderColor: "#31b3e4",
                                                },
                                            },
                                            ".css-i4bv87-MuiSvgIcon-root": {
                                                color: "#2C4992"
                                            },
                                            ".css-nxo287-MuiInputBase-input-MuiOutlinedInput-input": {
                                                fontSize: "0.9em !important;"
                                            }
                                        }}
                                    ></DatepickerFilter>
                                </Grid>
                                <Grid item xs={0} md={4} sx={{ margin: "0" }}>
                                    {/* <ValueRange
                                            title={"V. Original"}
                                            min={Number(valor_original?.options.sort(compareMin)[0].label)}
                                            max={Number(valor_original?.options.sort(compareMax)[0].label)}
                                            value={!valor_original?.value.length ? [Number(valor_original?.options.sort(compareMin)[0].label), Number(valor_original?.options.sort(compareMax)[0].label)] : valor_original?.value}
                                            onChange={(e, elemento) => { handleValue({ field: "valor_original", value: elemento }) }}
                                        /> */}
                                </Grid>
                                <Grid item xs={9} md={3.5}>
                                    <DatepickerFilter
                                        title={"Data de Finalização"}
                                        handleStart={(value) => {
                                            handleValue({ field: "data_finalizacao", value: [value, data_finalizacao?.value[1]] });

                                        }}
                                        handleEnd={(value) => {
                                            handleValue({ field: "data_finalizacao", value: [data_finalizacao?.value[0], value] });

                                        }}
                                        valueStart={data_finalizacao?.value[0]}
                                        valueEnd={data_finalizacao?.value[1]}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    borderColor: "#E2746F",
                                                },
                                            },
                                            ".css-i4bv87-MuiSvgIcon-root": {
                                                color: "#2C4992"
                                            },
                                            ".css-nxo287-MuiInputBase-input-MuiOutlinedInput-input": {
                                                fontSize: "0.9em !important;"
                                            }
                                        }}
                                    ></DatepickerFilter>
                                </Grid>
                            </Grid>
                        </Box>
                        <Divider
                            sx={{
                                marginBottom: 1,
                                marginTop: 5,
                                color: "#2B3A8B",
                            }}
                        />
                        <Box
                            m={3}
                            display="flex"
                            justifyContent="flex-end"
                            alignItems="flex-end"
                        >
                            <Tooltip title="Imprimir">
                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{ width: "fit-content", minWidth: "0" }}
                                    style={{
                                        backgroundColor: "#0032A0",
                                        width: "40px",
                                        marginRight: "20px",
                                        height: "40px",
                                    }}
                                    onClick={() => {

                                        if (amount > 1000) {
                                            return handleClickOpen(true)
                                        }
                                        else {

                                            const ids = groupsSelected.map(el => {
                                                return el.id
                                            });
                                            generatePdf(ids + "?&" + newFilter)
                                        }

                                    }}
                                >

                                    <PrintIcon sx={{ color: "white" }} />
                                </Button>
                                {/* <a
                                    href={link}
                                    style={{
                                        color: "white",

                                        backgroundColor: "#0032A0",
                                        width: "40px",
                                        height: "40px",
                                        padding: "6px 8px",
                                        borderRadius: "4px",

                                        display: "flex",
                                        alignItems: "center",

                                        justifyContent: "center",
                                        marginRight: "20px",
                                    }}
                                    target="_blank" rel="noreferrer"
                                    onClick={() => handlePreviw()}
                                >
                                    <PrintIcon sx={{ color: "white" }} />
                                </a> */}
                            </Tooltip>

                            <PopupState variant="popover" popupId="demo-popup-menu" >
                                {(popupState) => (
                                    <>
                                        <Grid>
                                            <Tooltip title="Exportar Excel/CSV">
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    sx={{ width: "fit-content", minWidth: "0" }}
                                                    style={{
                                                        backgroundColor: "#0032A0",
                                                        width: "40px",

                                                        height: "40px",
                                                    }}
                                                    {...bindTrigger(popupState)}
                                                >
                                                    <FileDownloadIcon
                                                        onClick={async () => await gerarCsv(newFilter, groupsSelected)}
                                                        color="disabled"
                                                        size="small"
                                                        sx={{ color: "white" }}
                                                    />
                                                </Button>
                                            </Tooltip>
                                        </Grid>

                                        <Menu {...bindMenu(popupState)}  >
                                            <MenuItem
                                                onClick={() => {
                                                    gerarXlsx(newFilter, filter, header, groupsSelected);
                                                }}
                                            >
                                                Excel(.xlsx)
                                            </MenuItem>

                                            <MenuItem>
                                                <CSVLink
                                                    asyncOnClick={true}
                                                    onClick={(event, done) => {
                                                        done(true)
                                                    }}
                                                    data={data2}
                                                    filename={"analytcs.csv"}
                                                    className="csvlink"
                                                    target="_blank"
                                                >
                                                    CSV
                                                </CSVLink>
                                            </MenuItem>
                                        </Menu>
                                    </>
                                )}
                            </PopupState>
                        </Box>
                        {visibleLegend &&
                            <Box sx={{ display: "flex", alignItems: "center", }} mb={1}>
                                <Typography sx={{
                                    fontSize: "12px",
                                    marginBottom: "2px",
                                    color: "rgb(44, 73, 146)",
                                    marginRight: "8px"
                                }}>
                                    Credor:
                                </Typography>
                                <Grid container spacing={2}>
                                    {groupsSelected.map((el, index) => (
                                        <Grid item key={index}>
                                            <Chip color="textBlue" sx={{ textTransform: "capitalize" }} avatar={<Avatar sx={{ background: "rgba(0, 0, 0, 0.26)", color: "white !important" }}>{index + 1}</Avatar>} label={el?.label} />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        }

                        <div style={{ minHeight: 400, width: "100%" }}>
                            {/* <DataGrid
                                experimentalFeatures={{ columnGrouping: true, }}
                                columnGroupingModel={columnGroupingModel}
                                rows={data}
                                columns={columns}
                                rowHeight={40}
                                checkboxSelection
                                disableSelectionOnClick
                                onSelectionModelChange={(arr) => setSelection({ init: false, select: [...arr] })}
                                selectionModel={selection.select}
                                components={{
                                    BaseCheckbox: (props) => (
                                        <Checkbox defaultValue={true} {...props} color="textBlue" />
                                    ),
                                }}
                                initialState={{
                                    pagination: {
                                        paginationModel: { page: 0, pageSize: 5 },
                                    },
                                }}
                                getRowId={(row) => row.id}
                                pageSizeOptions={[5, 10]}
                                rowsPerPageOptions={[]}
                            /> */}

                            <DataGrid
                                autoHeight
                                // pageSizeOptions={[5, 10, 25, 33]}
                                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                onPageSizeChange={(size) => {
                                    setPageSize(size);
                                    refresh(0, size);
                                }}
                                pagination

                                columns={columns}
                                rowCount={amount}
                                rows={result}
                                paginationMode="server"
                                getRowId={(row) => row.id}
                                pageSize={pageSize}
                                paginationModel={{
                                    pageSize: pageSize,
                                    page: page
                                }}
                                rowHeight={40}
                                experimentalFeatures={{ columnGrouping: true, }}
                                columnGroupingModel={columnGroupingModel}
                                checkboxSelection
                                disableSelectionOnClick
                                onSelectionModelChange={(arr) => { setSelection({ init: false, select: [...arr] }) }}
                                selectionModel={selection.select}
                                components={{
                                    BaseCheckbox: (props) => (
                                        <Checkbox defaultValue={true} {...props} color="textBlue" />
                                    ),
                                }}
                                sx={{
                                    "& .MuiDataGrid-cell": {
                                        border: "solid",
                                        borderWidth: " 0.3px",
                                        borderColor: "#31b3e4 !important",
                                    },
                                    "& .MuiDataGrid-columnHeader": {
                                        border: "solid",
                                        borderWidth: " 0.3px",
                                        borderColor: "#31b3e4 !important",
                                        background: "#C7D9FF"
                                    },
                                    "& .MuiDataGrid-columnHeader--filledGroup": {
                                        background: "#DEE7F9"
                                    },
                                    display: "flex", flexDirection: "column-reverse"
                                }}
                                onPageChange={(index) => { handlePageSize(index); }}
                                page={page}
                            />
                            <TablePagination
                                component="div"
                                count={amount}
                                page={page}
                                onPageChange={(index, i) => {
                                    handlePageSize(i)
                                }}
                                rowsPerPage={pageSize}
                                sx={{
                                    '& .MuiSelect-select': {
                                        display: 'none !important'
                                    },
                                    '& > div.MuiToolbar-root > div.MuiInputBase-root > svg': {
                                        display: 'none !important'
                                    },
                                    "& .MuiTablePagination-selectLabel": {
                                        display: 'none !important'
                                    }
                                }}
                            />
                        </div>
                    </Box>
                </CardSys>
            </Box >
        </Modal >

    )
}
